import { describeFields, FieldWidget } from '../common/fields';
import { UserNoteSchema } from './schemas';

export const USER_NOTE_FIELDS = describeFields(UserNoteSchema, {
  userId: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  lastEditDatetime: { widget: FieldWidget.DateTime },
  priorityDatetime: { widget: FieldWidget.DateTime },
  dueDatetime: { widget: FieldWidget.DateTime },
  note: { widget: FieldWidget.LongText },
  creator: {},
  creatorName: {},
  assignee: {},
  assigneeName: {},
  active: { widget: FieldWidget.Text },
  billingRelated: { widget: FieldWidget.Text },
});
